export function BootSplash() {
  return (
    <div className="chloromance-splash" role="status" aria-live="polite">
      <div className="watering-can" aria-hidden="true">
        <span className="watering-can-handle" />
        <span className="watering-can-spout" />
        <span className="watering-can-drop drop-one" />
        <span className="watering-can-drop drop-two" />
        <span className="watering-can-drop drop-three" />
      </div>
      <p>Water you waiting for?</p>
      <small>Fetching your chloromance vitals...</small>
    </div>
  );
}
